import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'
import { CarouselArrowProps } from './carousel-arrow.props'

interface CarouselArrowStyles {
  arrowContainer: Styles
  arrowWrapperCircle: Styles
  arrowIcon: Styles
}

interface ArrowStylesProps {
  transform?: string
  right?: string | number
  left?: string | number
  top?: string | number
}

export const useStyles = createUseStyles<CarouselArrowStyles, CarouselArrowProps>((theme) => {
  return {
    arrowContainer: (props) => {
      let arrowStyles: ArrowStylesProps = {
        top: 0,
        ...(props.isInverse && { transform: 'rotate(180deg)', right: 0 }),
      }
      if (props.isMdsCarousel) {
        arrowStyles = {
          ...(props.isInverse
            ? { transform: 'rotate(180deg)', right: theme.calcUnit(25), top: theme.calcUnit(-10) }
            : { left: theme.calcUnit(25), top: theme.calcUnit(-8) }),
        }
      }
      return {
        display: 'flex',
        position: 'absolute',
        zIndex: 1000,
        height: '100%',
        alignItems: 'center',
        padding: theme.calcUnit(6),
        background: props.isMdsCarousel ? undefined : 'linear-gradient(to right,  #16181A , rgba(22, 24, 26, 0))',
        ...arrowStyles,
      }
    },
    arrowWrapperCircle: {
      width: theme.calcUnit(32),
      height: theme.calcUnit(32),
      borderRadius: theme.calcUnit(theme.borderRadius.roundedXl),
      backgroundColor: theme.colors.inverseTextColor,
      position: 'relative',
      cursor: 'pointer',
    },
    arrowIcon: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-60%, -50%)',
    },
  }
})
